import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { MatTableDataSource } from "@angular/material/table";
import { ApiService } from "src/app/services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/services/common.service";
import { SelectionModel } from "@angular/cdk/collections";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormControl, FormGroup } from "@angular/forms";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
@Component({
  selector: "fury-callrail-lead-list",
  templateUrl: "./callrail-lead-list.component.html",
  styleUrls: ["./callrail-lead-list.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CallrailLeadListComponent implements OnInit, OnDestroy {
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  @Input()
  columns = [
    { name: "Added On", property: "addedOn", visible: true },
    { name: "Utm Source", property: "utmSource", visible: true },
    { name: "Lead Source", property: "leadSource", visible: true },
    { name: "Result Code", property: "resultCode", visible: true },
    { name: "First Name", property: "firstName", visible: true },
    { name: "Last Name", property: "lastName", visible: true },
    { name: "Email", property: "emailAddress", visible: true },
    { name: "Mobile No", property: "mobileNumber", visible: true },
    { name: "Business No", property: "businessPhoneNumber", visible: true },
    { name: "Address", property: "address", visible: true },
    { name: "City", property: "city", visible: true },
    { name: "State", property: "state", visible: true },
    { name: "Zip Code", property: "zipCode", visible: true },
    { name: "Ip Address", property: "ipAddress", visible: true },
    { name: "Tracking Number", property: "trackingNumber", visible: true },
    { name: "Duration", property: "duration", visible: true},
    { name: "Lead Status", property: "leadStatus", visible: true },
    { name: "Sold Amount", property: "soldAmount", visible: true },
    { name: "Result Count", property: "resultCount", visible: true },
    {
      name: "Posted to Vanilla Soft",
      property: "isPostedToVanillaSoft",
      visible: true,
    },
    { name: "Actions", property: "actions", visible: true },
    // { name: "Internal Url", property: "internalUrl", visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  leadSearchForm = new FormGroup({
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    utmSource: new FormControl(""),
    mobileNumber: new FormControl(""),
    businessPhoneNumber: new FormControl(""),
    emailAddress: new FormControl(""),
    leadSource: new FormControl(""),
  });
  ngUnsubscribe = new Subject<void>();
  kpiData: any;

  constructor(
    private apiservice: ApiService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService
  ) {}
  ngOnInit(): void {
    this.filterValue = "Call Rail Leads";
    this.router.onSameUrlNavigation = "reload";
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.pageIndex = res.page ? res.page - 1 : 0;
        this.pageSize = res.size ? (res.size === "all" ? 9999 : res.size) : 30;
        this.getCallRailLeadList();
      });
      this.getCallRailKpiData();
  }

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/lead/call-rail-lead-list?page=${this.pageIndex + 1}${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }`
    );
  }
  getCallRailLeadList() {
    this.apiservice
      .get(
        `${endpoints.leadManagement.getCallRailLeadList}?page=${
          Number(this.pageIndex) + 1
        }&size=${this.pageSize}&firstName=${
          this.leadSearchForm.value.firstName || ""
        }&lastName=${this.leadSearchForm.value.lastName || ""}&mobileNumber=${
          this.leadSearchForm.value.mobileNumber || ""
        }&emailAddress=${
          this.leadSearchForm.value.emailAddress || ""
        }&utmSource=${this.leadSearchForm.value.utmSource || ""}&leadSource=${
          this.leadSearchForm.value.leadSource || ""
        }&businessPhoneNumber=${
          this.leadSearchForm.value.businessPhoneNumber || ""
        }`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            if (res.body?.callRailLeads.data) {
              this.itemList = res.body?.callRailLeads.data;
              this.totalCount = res.body?.callRailLeads.total;
              this.dataSource = new MatTableDataSource(this.itemList);
              this.cdr.detectChanges();
            } else {
              this.itemList = undefined;
            }
          }
        },
        (error: HttpErrorResponse) => {
          this.apiservice.alert(error.message, ErrorType.Error);
        }
      );
  }

  navigateDetailsPage(data: any) {
    this.router.navigateByUrl(
      "/lead/callrail-lead-details/" + data.callRailLeadId
    );
  }

  search() {
    this.getCallRailLeadList();
  }
  getCallRailKpiData(){
    this.apiservice.get(endpoints.leadManagement.getCallRailKpiData)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (res: HttpResponse<any>) => {
        if(res.body){
          this.kpiData = res.body;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.apiservice.alert(err.message, ErrorType.Error);
      }
    })
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
